import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { host } from '../../App';
import "./PO_raw_material.css";

function PO_RM(props) {
  var token = (window.localStorage.getItem("acessToken"));
  const user = JSON.parse(window.localStorage.getItem("Name"));
  var [Date1, setDate1] = useState(new Date());
  const [Date2, setDate2] = useState(Date1.toISOString().slice(0, 10));
  const [part_dataset, setpart_dataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  var length = 0;
  const [isValid, setisValid] = useState(true);

  const [data, setData] = useState([
    { Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' },
    { Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' }
  ]);

  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  });

  useEffect(() => {
    Axios.get(`https://` + host + `/api/supplychain/part_dataset/${token}`).then((data) => {
      setpart_dataset(data.data);
    });
  }, []);

  useEffect(() => {
    const newData = data.map((line) => ({ ...line, Date: Date2 }));
    setData(newData);
  }, [Date2])

  const submitValue = (e, index) => {
    const newData = [...data];
    newData[index].ITEM_NO = e.target.value;

    newData[index].Supplier = (part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).SUPPLIER);
    newData[index].Item_Description = part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).ITEM_DESCRIPTION;
    newData[index].Unit = part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).UNIT;
    newData[index].Currency = part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).CURR;
    newData[index].CUSTOMS = part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).CUSTOMS;
    newData[index].SHIPPING = part_dataset.find((x) => `${x.ITEM_NO}` === e.target.value).SHIPPING;
    setData(newData);
  }

  const addLines = () => {
    if (data.length < 15) {
      const newData = [...data];
      for (let i = 0; i < 5; i++) {
        newData.push({ Po_No: '', ITEM_NO: '', Po_Date: '', Item_Description: '', Supplier: '', Qty: '', Unit: '', Unit_Cost: '', Currency: '', ETA: '', Notes: '' });
      }
      setData(newData);
    } else {
      window.alert("Lines Reached maximum limit")
    }
  }

  const submitdata = () => {
    const filteredData = [];
    setisValid(true);

    data.forEach(item => {
      if (
        item.Po_Date &&
        item.Po_No &&
        item.ITEM_NO &&
        item.Supplier &&
        item.Item_Description &&
        item.ETA
      ) {
        const newData = [
          item.Po_Date,
          item.Po_No,
          item.ITEM_NO,
          item.Supplier,
          item.Item_Description,
          item.Qty,
          item.Unit,
          item.ETA,
          item.Unit_Cost,
          item.Currency,
          item.Notes,
          item.CUSTOMS,
          item.SHIPPING
        ];
        filteredData.push(newData);
      } else if (
        item.Po_No && item.ITEM_NO ||
        item.Po_No && item.Supplier ||
        item.Po_No && item.Item_Description ||
        item.Po_No && item.ETA ||
        item.Po_No && item.Po_Date) {
        console.log("Please Enter all values!")
        setisValid(false);
      }
      length = filteredData.length;
    });

    setIsLoading(true);

    if (filteredData.length > 0) {
      setTimeout(() => {
        Axios.post(`https://` + host + `/supplychain/PO_RM`, { filteredData })
          .then((response) => {
            if (response.status === 200) {
              window.alert(response.data.message);
              setIsLoading(false);
              window.location.reload();
            }
          })
          .catch(error => {
            window.alert("Error Occured")
            setIsLoading(false);
          });
      }, 2000);
    } else {
      window.alert("No Data !")
      setIsLoading(false);
    }
  }

  const toggleShipping = (e, index) => {
    const newData = [...data];
    newData[index].SHIPPING = newData[index].SHIPPING === "Yes" ? "No" : "Yes";
    setData(newData);
  };

  const toggleCustoms = (e, index) => {
    const newData = [...data];
    newData[index].CUSTOMS = newData[index].CUSTOMS === "Yes" ? "No" : "Yes";
    setData(newData);
  };

  return (
    <div className="rmPage">
      <div className="rmCard">
        <div className="rmHeader">
          <div className="rmHeaderLeft">
            <div className="rmTitle">PO RAW MATERIAL</div>
            <div className="rmSub">Create purchase order lines</div>
          </div>
          <div className="rmHeaderRight">
            <button onClick={addLines} class="btn btn-success rmAddBtn">Add Row</button>
          </div>
        </div>

        <div className="rmTableWrap">
          <table class="table table-bordered rmTable">
            <tbody>
              <tr>
                <th>Po No</th>
                <th>Item No</th>
                <th>Po Date</th>
                <th>Item Description</th>
                <th>Supplier</th>
                <th>Qty</th>
                <th>Unit</th>
                <th>Unit Cost</th>
                <th>Currency</th>
                <th>ETA</th>
                <th>CUSTOMS</th>
                <th>SHIPPING</th>
                <th>Notes</th>
              </tr>

              {data.map((line, index) => (
                <tr>
                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_No = e.target.value;
                        setData(newData);
                      }}
                      Value={data[index].Po_No}
                      placeholder="Po No"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].ITEM_NO = e.target.value;
                        setData(newData);
                      }}
                      onBlur={(e) => submitValue(e, index)}
                      list="PartNo"
                      id="operator"
                      placeholder="Enter Item No"
                    />
                    <div className="scrollbar">
                      <datalist id="PartNo">
                        <option></option>
                        {part_dataset.map((x) => {
                          return <option value={x.ITEM_NO}>{x.ITEM_NO}-{x.SUPPLIER}</option>;
                        })}
                      </datalist>
                    </div>
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Po_Date = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Po Date"
                      Value={data[index].Po_Date}
                      name="target"
                      required
                    />
                  </td>

                  <td class="col-2">
                    <input
                      type="text"
                      className="form-control form-rounded"
                      Value={data[index].Item_Description}
                      placeholder="Item Description"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      value={data[index].Supplier}
                      placeholder="Supplier"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Supplier = e.target.value;
                        setData(newData);
                      }}
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only numbers
                        if (!/^\d*\.?\d*$/.test(value)) {
                          alert("Numbers only");
                          return;
                        }

                        const newData = [...data];
                        newData[index].Qty = value;
                        setData(newData);
                      }}
                      placeholder="Qty"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      placeholder="Unit"
                      Value={data[index].Unit}
                      list="unit"
                    />
                    <datalist id='unit'>
                      <option>Each</option>
                      <option>Feet</option>
                      <option>FT</option>
                      <option>GAL</option>
                      <option>SHEET</option>
                      <option>KG</option>
                      <option>LBS</option>
                      <option>METER</option>
                      <option>PACK</option>
                      <option>PC</option>
                      <option>ROLL</option>
                      <option>YARDS</option>
                    </datalist>
                  </td>

                  <td>
                    <input
                      type="text"
                      className="form-control form-rounded"
                      placeholder="Unit Cost"
                      onChange={(e) => {
                        const value = e.target.value;

                        // Allow only numbers and decimal
                        if (!/^\d*\.?\d*$/.test(value)) {
                          alert("Numbers only");
                          return;
                        }

                        const newData = [...data];
                        newData[index].Unit_Cost = value;
                        setData(newData);
                      }}
                    />
                  </td>

                  <td>
                    <input
                      type="select"
                      className="form-control form-rounded"
                      placeholder="Currency"
                      Value={data[index].Currency}
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Currency = e.target.value;
                        setData(newData);
                      }}
                      list='currency'
                    />
                    <datalist id='currency'>
                      <option>CAD</option>
                      <option>USD</option>
                    </datalist>
                  </td>

                  <td>
                    <input
                      type="date"
                      className="form-control form-rounded"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].ETA = e.target.value;
                        setData(newData);
                      }}
                      placeholder="Po Date"
                      name="target"
                      required
                    />
                  </td>

                  <td>
                    <button className="btn btn-light" onClick={(e) => toggleCustoms(e, index)}>
                      {data[index].CUSTOMS}
                    </button>
                  </td>

                  <td>
                    <button className="btn btn-light" onClick={(e) => toggleShipping(e, index)}>
                      {data[index].SHIPPING}
                    </button>
                  </td>

                  <td>
                    <input
                      type="textarea"
                      className="form-control form-rounded"
                      placeholder="Notes"
                      name="Supervisor_notes"
                      onChange={(e) => {
                        const newData = [...data];
                        newData[index].Notes = e.target.value;
                        setData(newData);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="rmFooter">
          <button onClick={submitdata} class="btn btn-primary rmSubmitBtn">Submit</button>
        </div>

        {isLoading ?
          <div className='overlay rmOverlay'>
            <div className="loading-container">
              <div className="loading-dots">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
              <p className='loading'>Submitting</p>
            </div>
          </div> : null}
      </div>
    </div>
  )
}

export default PO_RM;
